import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";
import AttendeesnetworkMenuIcon from "./attendeesnetwork-menu-icon";
import TableContentPopuatten from "./table-content-popular-attendees";
import TableContentMstactvnetwrk from "./table-content-mstactvnetwrk-attendees";
import TableContentMostsearchAttendeesnetwork from "./table-content-mostsearch-attendeesnetwork";

import AttendeesnetworkEngmntBarChart from "./attendeesnetwork-engmnt-barchart";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";
import {
  fetchPopuattenTableData,
  fetchMstactvattenTableData,
  fetchAttenMostsearkeysTableData,
  fetchAttnNetwrkEngaBarChart,
} from "AttendeesnetworkActions";

import { attendeesnetworkscanscount } from "AttendeesnetworkScansAction";
import { attendeesNetworkProfViewCount } from "AttendeesnetworkProfviewAction";
import { attendeesNetworkSearchCount } from "AttendeesnetworkAttesearAction";
import { attendeesNetworkFavoCount } from "AttendeesnetworkAttefavoAction";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class AttendeesnetworkInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
      loader: false,
    };
  }

  //
  componentDidMount() {
    this.props.attendeesnetworkscanscount(
      this.props.session,
      (attendeesnetworkscansresponse) => {
        if (attendeesnetworkscansresponse.error === 0) {
        }
      }
    );

    this.props.attendeesNetworkFavoCount(
      this.props.session,
      (attendeesnetworkfavocountResponse) => {
        if (attendeesnetworkfavocountResponse.error === 0) {
        }
      }
    );

    //Call to Number of search done on the attendees list count
    this.props.attendeesNetworkSearchCount(
      this.props.session,
      (attendeesnetworksearchcountResponse) => {
        if (attendeesnetworksearchcountResponse.error === 0) {
        }
      }
    );

    // Call to Attendee's profile views
    this.props.attendeesNetworkProfViewCount(
      this.props.session,
      (attendeesnetworkprofviewcountResponse) => {
        if (attendeesnetworkprofviewcountResponse.error === 0) {
        }
      }
    );

    // Call Popular Attendees Table data list
    this.props.fetchPopuattenTableData(
      this.props.session,
      (fetchpopuattentabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call Most Active network Attendees Table data list
    this.props.fetchMstactvattenTableData(
      this.props.session,
      (fetchmstactvattentabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call to Most search keywords (most search keywords related to attendees)
    this.props.fetchAttenMostsearkeysTableData(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchattenmostsearkeystabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call to Network Engagement (Chart view of how active users has been using the networking feature of the app over the selected date range)
    this.props.fetchAttnNetwrkEngaBarChart(
      this.props.session,
      (fetchattnnetwrkengabarchartResponce) => {
        this.setState({ loading: false });
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Attendees Messaging menu divs

  renderAttendeesnetworkMenuIcons() {
    return _.map(
      this.props.attendeesNetworkMenu,
      (attendeesNetworkMenuItem) => {
        return (
          <AttendeesnetworkMenuIcon
            menu={attendeesNetworkMenuItem}
            key={attendeesNetworkMenuItem.key}
          />
        );
      }
    );
  }

  // Send function with props for barchartdate change
  onDateChartChangeFc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });

    this.props.attendeesnetworkscanscount(
      this.props.session,
      (attendeesnetworkscansresponse) => {
        if (attendeesnetworkscansresponse.error === 0) {
        }
      }
    );

    this.props.attendeesNetworkFavoCount(
      this.props.session,
      (attendeesnetworkfavocountResponse) => {
        if (attendeesnetworkfavocountResponse.error === 0) {
        }
      }
    );

    //Call to Number of search done on the attendees list count
    this.props.attendeesNetworkSearchCount(
      this.props.session,
      (attendeesnetworksearchcountResponse) => {
        if (attendeesnetworksearchcountResponse.error === 0) {
        }
      }
    );

    // Call to Attendee's profile views
    this.props.attendeesNetworkProfViewCount(
      this.props.session,
      (attendeesnetworkprofviewcountResponse) => {
        if (attendeesnetworkprofviewcountResponse.error === 0) {
        }
      }
    );

    // Call Popular Attendees Table data list
    this.props.fetchPopuattenTableData(
      this.props.session,
      (fetchpopuattentabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call Most Active network Attendees Table data list
    this.props.fetchMstactvattenTableData(
      this.props.session,
      (fetchmstactvattentabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call to Most search keywords (most search keywords related to attendees)
    this.props.fetchAttenMostsearkeysTableData(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchattenmostsearkeystabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call to Network Engagement (Chart view of how active users has been using the networking feature of the app over the selected date range)
    this.props.fetchAttnNetwrkEngaBarChart(
      this.props.session,
      (fetchattnnetwrkengabarchartResponce) => {
        this.setState({ loading: false });
      }
    );
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        {/* Header section */}
        {!this.state.loading ? (
          <AnalyticsCommonHeader
            finishOperationsCallback={this.mainCallback}
            callFrom="Attendees Network"
            xchart={this.onDateChartChangeFc.bind(this)}
          />
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - screenHeightLeftFromTop,
          }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <ul className="nav nav-pills dashboardNavPill">
                {this.renderAttendeesnetworkMenuIcons()}
              </ul>
              <div className="mt-20"></div>
              <div className="panel-body ">
                {this.props.attnnetwrkengabarchart ? (
                  <AttendeesnetworkEngmntBarChart
                    attnnetwrkengabarchart={this.props.attnnetwrkengabarchart}
                    newprop={this.state.loader}
                  />
                ) : (
                  ""
                )}
                <TableContentPopuatten />
                <TableContentMstactvnetwrk />
                <TableContentMostsearchAttendeesnetwork />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, attendeesNetworkMenu, attendeesnetworkSelectedItem } =
    state;

  var totalscans = state.attendeesnetworkTotalScans
    ? state.attendeesnetworkTotalScans
    : [];
  var popuatten = state.attendeesnetworkPopuattenTablelist
    ? state.attendeesnetworkPopuattenTablelist
    : [];
  var mstactvatten = state.attendeesnetworkMstactvattenTablelist
    ? state.attendeesnetworkMstactvattenTablelist
    : [];
  var mostsearkeysatten = state.attendeesnetworkMostsearkeysTablelist
    ? state.attendeesnetworkMostsearkeysTablelist
    : [];
  var attnnetwrkengabarchart = state.attendeesnetworkEngagementbarChart
    ? state.attendeesnetworkEngagementbarChart.response
    : [];
  var datePropsMainPg = state.analyticscommondatepropsreducer;
  //
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    attendeesNetworkMenu,
    attendeesnetworkSelectedItem,
    totalscans,
    popuatten,
    mstactvatten,
    mostsearkeysatten,
    attnnetwrkengabarchart,
    datePropsMainPg,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  attendeesnetworkscanscount,
  fetchPopuattenTableData,
  fetchMstactvattenTableData,
  fetchAttenMostsearkeysTableData,
  fetchAttnNetwrkEngaBarChart,
  attendeesNetworkProfViewCount,
  attendeesNetworkSearchCount,
  attendeesNetworkFavoCount,
})(AttendeesnetworkInside);
